import { Loading } from 'element-ui';
let debounce = require('lodash/debounce');

let options = {
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.7)'
};
let loadingInstance = null;
const delayedClose = debounce(() => {
    const instance = loadingInstance;
    loadingInstance = null;
    if (instance) instance.close();
}, 300);

export const loading = {
    open: function() {
        // 新请求到来时撤销旧关闭任务，避免旧回调误关当前浮层。
        delayedClose.cancel();
        if (!loadingInstance) loadingInstance = Loading.service(options);
    },
    close: function() {
        if (loadingInstance) delayedClose();
    }
};

const install = function(Vue) {
    Vue.prototype.$loading = loading;
};

export default install;
